const TRANSLATIONS_EN = {
  button_group: {
    yes: "Yes",
    no: "No",
    next: "NEXT",
    back: "BACK",
    ok: "OK",
    login: "LOGIN",
    close: "Close",
    logout: "Logout",
    managePreferences: "Manage Preferences",
    changePassword: "Change Password",
    add: "ADD",
    update: "UPDATE",
    add_new: "Add new",
    added: "ADDED",
    get_report: "GET REPORT",
    cancel: "CANCEL",
    add_product: "ADD PRODUCT",
    change_password: "CHANGE PASSWORD",
    move: "MOVE",
    skip_and_add: "SKIP & ADD",
    add_new: "ADD NEW",
    skip_add: "SKIP & ADD",
    skip_update: "SKIP & UPDATE",
    profile: "Profile",
    profile_icon_updated: "Profile icon updated",
    remove: "Remove",
    adjust: "Adjust",
    save: "Save",
    change: "Change",
    approve: "Approve",
    decline: "Decline",
    delete: "Delete",
  },
  drawer: {
    "price-monitor": "Price Monitor",
    dashboard: "Dashboard",
    "manage-price": "Manage Price",
    "purchase-stock": "Purchases & Stock",
    logout: "Log out",
  },
  login_screen: {
    sign_in: "SIGN IN",
    username: "Username",
    username_required: "Username required",
    enter_valid_email: "Enter Valid Email",
    password: "Password",
    password_required: "Password required",
    confirm_password: "Confirm password",
    forgot_password: "Forgot password?",
    reset_password: "Reset password",
    contact_your_admin:
      "Contact your system admin to get your username and password.",
    copyright: "KARAN RETAIL LTD © {{year}}",
    uppercase_required: "Uppercase required",
    lowercase_required: "Lowercase required",
    number_required: "Number required",
    min_chars: "Min chars 8",
    password_mismatch: "Password mismatched",
    unauthorised_access: "Unauthorised access",
  },
  price_monitor_screen: {
    regional_price_monitor: "Regional Price Monitor",
    select_forecourt: "Select Forecourt",
    competing: "Competing",
    adjust_price: "Adjust Price",
    no_products: "No Products",
    set_range: "Set Range",
  },
  manage_price_screen: {
    manage_price: "Manage Price",
    last_updated: "Last updated",
    update_price: "Update Price",
    brand: "Brand",
    site_id: "Site ID",
    site_name: "Site Name",
    address: "Address",
    prices: "Prices(Gross)",
    download: "Download",
    enter_site_name: "Enter Site Name",
    enter_new_price: "Enter new price",
    confirm_new_price: "Confirm new price",
    new_price: "New Price(Gross)",
    price_updated: "Price Updated.",
    url_copied: "URL copied",
    current_price_margin: "Current price & margin(Gross)",
    previous_price_margin: "Previous price & margin(Gross)",
    last_updated_price_margin: "{{date}} price & margin",
  },
  purchase_screen: {
    purchase_stock: "Purchases & Stock",
    add_delivery: "Add Delivery",
    period: "Period",
    select_forecourt: "Select Forecourt",
    cost_price: "Cost Price(Net)",
    new_stock: "{{type}} S",
    available_stock: "{{type}} AS",
    bunker_new_stock: "Bunker new Stock",
    bunker_available_stock: "Bunker Available Stock",
    purchase_price: "Purchase Price(Net)",
    delivery_in_litre: "{{stock_type}} Delivery in Litre",
    date_time: "Date & Time",
    add_stock: "Add Stock",
    stock_added: "Stock Added.",
    cost_added: "Cost Added.",
    no_stock_history: "No stock history",
    add: "Add",
    cancel: "Cancel",
    purchase_price_with_time: "Purchase Price {{time}}",
    add_price: "Add Price",
    date: "Date",
    cost: "Cost",
    sum_of_delivery: "Sum of delivery",
  },
  dashboard_screen: {
    dashboard: "Dashboard",
    add_sales_data: "Add Sales Data",
    cost_price: "Cost Price(Net)",
    sell_price: "Sell Price(Net)",
    margin: "Margin",
    manual_sales_data: "Manual Sales Data",
    select_date: "Select Date",
    volume_sold: "Volume sold ({{name}})",
    price: "Price",
    volume: "Volume",
    week_price: "Price {{week}}(Gross)",
    week_volume: "Volume {{week}}",
    week: "Week",
    compare_with: "Compare with",
    this_week: "This week",
    last_week: "Last week",
    select_product: "Select Product",
    sales_success: "Sales Success.",
    date_time: "Date & Time",
    no_data: "No Data",
    closing_volume: "Closing Volume",
    stock_deficit: "Stock deficit",
    period: "Period",
    date: "Date",
    mtd: "{{code}} MTD",
    cost: "Cost price",
    sell: "Sell price",
    vol: "Vol",
    vol_wtd: "Vol WTD",
    vol_splw: "Vol SPLW",
    date: "Date",
  },
};

export default TRANSLATIONS_EN;
